<template>
  <div :class="$style['order-history']">
      <table>
        <tr v-if="placementDetails.parentOrderId">
            <td>重采前订单：</td>
            <td>
              <router-link  :to="`/mall-order-all/order-detail/${placementDetails.parentOrderId}/detail`">{{placementDetails.previousSampleId}}</router-link>
            </td>
        </tr>
        <tr v-for="item in orderHistoryList" :key="item.id">
            <td>重采订单：</td>
            <td>
              <router-link  :to="`/mall-order-all/order-detail/${item.id}/detail`">{{item.newSampleId}}</router-link>
            </td>
        </tr>
      </table>
  </div>
</template>

<script>
export default {
  props: {
    orderHistoryList: {
      type: Array,
      default: function () {
        return []
      }
    },
    placementDetails: {
      type: Object,
      default: function () {
        return {}
      }
    }
  }
}
</script>

<style module lang="less">
@import "~less/var";
.order-history{
    :global
    table{
        border: none;
        border-spacing:0;
        tr{
            td{
                line-height: 30px;
                font-size: 14px;
                a{
                  display: inline-block;
                  color:@mainColor;
                }
            }
            >:first-child{
                display: flex;
                color:@mainColor;
                justify-content: flex-end;
                white-space:nowrap
            }
        }
    }
}
</style>
